import { Component, Vue, Model, Prop } from 'vue-property-decorator';
import {strengthColor} from '@/lib/strengthColor';



@Component
export default class Input extends Vue {

  @Prop({ default: "" }) readonly label!: string;
  @Prop({ default: false }) readonly disabled!: boolean;
  @Prop({ default: 'string' }) readonly type!: string;
  @Prop({ default: false }) readonly auth!: boolean;
  @Prop({ default: false }) readonly readonly!: boolean;
  @Prop({ default: '' }) readonly name!: string;
  @Prop({ default: '' }) readonly autocomplete!: string;
  @Prop({ default: false }) readonly enableStrength!: false;
  @Prop({ default: 0 }) readonly passwordStrength!: number;

  @Model("input", { required: true }) value!: string;

  error: boolean = false;
  valid: boolean = true;
  phoneValue: string = '';
  formattedPhoneValue: string = '';
  preventNextIteration: boolean = false;

  get passwordColor(){

    if (this.type !== 'password' || !this.enableStrength || !this.value) return '#d0c9ca';

    return strengthColor(this.passwordStrength)
  }


  input(event: any){

    const {value} = event.target;

    if (this.type === 'email'){

      this.valid = this.validEmail(value);
    }


    if (this.name === 'FirstName' ||  this.name === 'LastName' || this.name === 'CompanyName'){

      this.valid = value.length >= 2;

    }

    if (this.type === 'number'){

      this.valid = !isNaN(Number(value));

      if (this.name === 'MobilePhone'){

        const validSize = value.length >= 1 || !value.length;
        this.valid = validSize && !isNaN(Number(value));

      }

    }

    if (this.name === 'Zip'){

      this.valid = value.length <= 5
    }

    if (this.name === 'State'){

      this.valid = isNaN(Number(value)) && value.length <=2;
      
    }

    this.$emit('setError', this.valid);    

    this.$emit('input', value);


  } 

  blur(){

    this.error = !this.valid;

  }

  validEmail(email: string){

    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);

  }

  focusOutPhone(){

    if (this.preventNextIteration) {
      this.preventNextIteration = false;
      return;
    }
    
    if (this.formattedPhoneValue){

      const newValue = this.formattedPhoneValue.replace(/-/g, '').match(/(\d{1,10})/g)

      if (newValue){
        this.phoneValue = newValue[0];
      }
      // Format display value based on calculated currencyValue
      this.formattedPhoneValue = this.phoneValue.replace(/(\d{1,3})(\d{1,3})(\d{1,4})/g, '$1-$2-$3');
      
    }

    this.valid =  this.formattedPhoneValue.length === 12 ;
    this.error = !this.valid &&
     Boolean(this.formattedPhoneValue);

    console.log('this.valid', this.valid);

    this.$emit('setError', this.valid);

    this.$emit('input', this.phoneValue);

  }


}